export default __webpack_public_path__ + "static/media/pexels-vinícius-caricatte.2d6549a1.svg";